module.exports = __webpack_public_path__ + "static/media/xangaVenturesImage.8d775213.png";